import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './DeleteEmployeeModal.styl';
class DeleteEmployeeModal extends React.Component {
    render() {
        const { title, t, onSubmit, onCancel, name } = this.props;
        return (React.createElement("div", { className: classnames(styles.modalWrapper, styles.smallWrapper) },
            React.createElement("div", { className: styles.modalHeaderNoBorder }, t('deleteModal.title')),
            React.createElement("div", { className: styles.modalBody }, t('deleteModal.confirmMessage', { name })),
            React.createElement("div", { className: styles.buttonsRow },
                React.createElement(Button, { variant: 'filled', className: styles.discardButton, onClick: () => onCancel(title) }, t('deleteModal.discardButton')),
                React.createElement(Button, { variant: 'filled', className: styles.confirmButton, onClick: onSubmit }, t('deleteModal.confirmButton')))));
    }
}
export default DeleteEmployeeModal;
